import moment, {Moment} from "moment";
import {DateFormatPipe} from "orpyx-web-common";

export const StatusLastChangedDateFormat = 'YYYY-MM-DD';

export const statusLastChangedPipe = (date: Moment | null | undefined, defaultValue: string = ''): string => {
    if (!date) {
        return defaultValue;
    }

    const utcDate = date.clone().utc();
    const formattedDate = DateFormatPipe(utcDate, StatusLastChangedDateFormat);
    if (!formattedDate) {
        return defaultValue;
    }

    const days = Math.max(moment.utc().startOf('day').diff(utcDate.clone().startOf('day'), 'days'), 0);
    const elapsed = days === 0
        ? 'today'
        : `${days} ${days === 1 ? 'day' : 'days'}`;

    return `${formattedDate} (${elapsed})`;
};
